import React from 'react';
import Legend from '../legend/components/Legend';


const LegendPanel: React.FC = () => {
  return (
    <aside id="sidebar">
      <section>
        <h3>Legend</h3>
        <h4>Layers</h4>
        <Legend />
      </section>
    </aside>
  );
}

export default LegendPanel;